import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-2">最新快讯</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">滚动更新 · 实时追踪娱乐动态</p>
        <div className="max-w-[800px] mx-auto">
          <div className="relative pl-6 md:pl-8 border-l-2 border-background-200">
            {updatesData.map((item) => (
              <div key={item.id} className="relative pb-5 md:pb-6 last:pb-0">
                <div className="absolute -left-[25px] md:-left-[29px] top-0.5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold bg-accent-100 text-accent-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  {item.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}